import { render, staticRenderFns } from "./PosPromotionNewDetail.vue?vue&type=template&id=4f35e8f7&scoped=true&"
import script from "./PosPromotionNewDetail.vue?vue&type=script&lang=js&"
export * from "./PosPromotionNewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f35e8f7",
  null
  
)

export default component.exports